import { render, staticRenderFns } from "./GenericAuditChangesExplainer.vue?vue&type=template&id=2bb66744&scoped=true&"
import script from "./GenericAuditChangesExplainer.vue?vue&type=script&lang=ts&"
export * from "./GenericAuditChangesExplainer.vue?vue&type=script&lang=ts&"
import style0 from "./GenericAuditChangesExplainer.vue?vue&type=style&index=0&id=2bb66744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb66744",
  null
  
)

export default component.exports